import React, { Component } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { addLocation, removeLocation, toggleView } from "../actions";
import Summary from "./Summary";
import NavigationMenu from "./NavigationMenu";
import HotKeys from "./HotKeys";
import "../styles/Search.css";
import track from "../lib/tracking"

type Props = {
  selectedLocations: [],
  addLocation: Function
};
type State = {
  formLocation: string
};

const mapStateToProps = (state, ownProps) => {
  return {
    selectedLocations: state.selectedLocations
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    addLocation: location => dispatch(addLocation(location)),
    removeLocation: location => dispatch(removeLocation(location)),
    nextPage: () => dispatch(toggleView("target"))
  };
};

class LocationsFormContainer extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      formLocation: "",
      searchLocations: ""
    };
    (this: any).handleChange = this.handleChange.bind(this);
    this.fetchLocations = _.debounce(this.fetchLocations, 300).bind(this);
  }
  handleChange(value: any) {
    if (value !== "") {
      this.setState({
        formLocation: value
      });
      this.fetchLocations(value);
    } else {
      this.setState({
        formLocation: value
      });
      this.setState({ searchLocations: [] });
    }
  }

  fetchLocations(location: string) {
    if (!location) {
      return;
    }
    fetch(
      `${window.config.base_url}/search?location_types=['city','country']&type=adgeolocation&access_token=${window.config.access_token}&q=${location}&locale=en_GB`
    )
      .then(response => response.json())
      .then(responseJson =>
        this.setState({ searchLocations: responseJson.data })
      );
  }
  nextPage = (e, focus) => {
    if (focus && focus.tagName === "INPUT") {
      return;
    }
    this.props.nextPage();
  };

  render() {
    const keyMap = {
      nextPage: "arrowright"
    };

    const handlers = {
      nextPage: this.nextPage
    };
    return (
      <HotKeys keyMap={keyMap} handlers={handlers}>
        <div className="column">
          <h1 className="title">Location Selection</h1>
          <h2 className="sub-title">
            Type the countries, cities or areas you are looking to target.
          </h2>
          <div className="column__section">
            <form
              onSubmit={event => {
                event.preventDefault();
              }}
            >
              <label className="search__label" htmlFor="location">Search</label>
              <input
                type="text"
                className="input input--text"
                value={this.state.formLocation}
                onChange={e => this.handleChange(e.target.value)}
              />
              <div className="search">
                {this.state.searchLocations &&
                  this.state.searchLocations.map(location => (
                    <div className="option bg-gray" key={location.key}>
                      <p className="option__label">
                        {location.name +
                          ", " +
                          (location.region || "") +
                          "  (" +
                          location.country_code +
                          ")"}

                      </p>
                      <span className="option__tag">{location.type}</span>
                      <div className="option__actions">
                        <button
                          className="option__action"
                          onClick={() => {track("location_added",{location: location.name});this.props.addLocation(location);}}
                        >
                          Add
                        </button>
                      </div>
                    </div>
                  ))}
                {(!this.state.searchLocations ||
                  this.state.searchLocations.length === 0) &&
                  <p className="search__empty">No results to display yet.</p>}
              </div>
            </form>
            <div className="results">
              <label className="search__label" htmlFor="location">
                Added Location
              </label>
              {this.props.selectedLocations.map(location => (
                <div className="option bg-gray" key={location.key}>
                  <p className="option__label">
                    {location.name +
                      ", " +
                      (location.region || "") +
                      "  (" +
                      location.country_code +
                      ")"}
                  </p>
                  <span className="option__tag">{location.type}</span>
                  <div className="option__actions">
                    <a
                      onClick={() => this.props.removeLocation(location)}
                      className="button--circular"
                    >
                      <i className="fa fa-times" />
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <hr className="separator" />

          <NavigationMenu next="target" />
          <Summary />
        </div>
      </HotKeys>
    );
  }
}

const LocationsForm = connect(mapStateToProps, mapDispatchToProps)(
  LocationsFormContainer
);

export default LocationsForm;



// WEBPACK FOOTER //
// ./src/components/LocationsForm.js